import { FC, PropsWithChildren, useContext, useState } from "react";
import NotificationDispatch, { showErrorNotification } from "../../context/notificationContext";
import { useI18n } from "../../hooks/useTranslations";
import { useApi } from "../../http/api";
import { isEmbed, isImage, isMobile, isVideo } from "../../types/utils";
import PreviewFileDialog from "./PreviewFileDialog";

type DownloadLinkProps = PropsWithChildren<{
  url: string;
  fileName: string;
}>;

const DownloadLink: FC<DownloadLinkProps> = ({ children, url, fileName }) => {
  const i18n = useI18n();
  const api = useApi();
  const dispatch = useContext(NotificationDispatch);
  const [docUrl, setDocUrl] = useState<string>();

  const onClick = async () => {
    if (!isMobile && (isVideo(fileName) || isImage(fileName) || isEmbed(fileName))) {
      const docUrl = await api.createObjectURL(url + `?t=${new Date().getTime()}`, true);
      setDocUrl(docUrl);
      return;
    }
    api.downloadFile(url + `?t=${new Date().getTime()}`, fileName);
  };

  return (
    <>
      <a
        href={url}
        onClick={(e) => {
          e.preventDefault();
          onClick().catch((err) => dispatch(showErrorNotification(i18n, err)));
          return false;
        }}
      >
        {children}
      </a>
      <PreviewFileDialog fileName={fileName} onClose={() => setDocUrl(undefined)} docUrl={docUrl} />
    </>
  );
};

export default DownloadLink;
